import { render, staticRenderFns } from "./UserDetailComponentNew.vue?vue&type=template&id=9fe303bc&scoped=true&"
import script from "./UserDetailComponentNew.vue?vue&type=script&lang=js&"
export * from "./UserDetailComponentNew.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailComponentNew.vue?vue&type=style&index=0&id=9fe303bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe303bc",
  null
  
)

export default component.exports